import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { ThTravellerComponent } from "./th-traveller.component";
import { MatTableModule } from "@angular/material/table";
import { TravellerDataTranslationModule } from "libraries/service/traveller-data-translation/traveller-data-translation.module";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        MatTableModule,
        TravellerDataTranslationModule,
        FontAwesomeModule,
    ],
 exports: [
     ThTravellerComponent
 ],
 declarations: [
     ThTravellerComponent
 ],
})
export class ThTravellerModule { }
